const splitStr = (str, num) => {
  let data = "";
  if (str) {
    data = str
      .split(" ")
      .filter((item) => item != "")
      .splice(0, 2);

    if (num) {
      data = data.join("·");
    } else {
      data = data.join(" ");
    }
  }

  return data;
};

export { splitStr };
